import type { Delivery } from "../../../../../utils/backend-types";

export function getDeliveryCountFromContract(
  deliveries: Array<Delivery>,
  contractId: string
): number {
  return deliveries.filter((delivery) => delivery.contract === contractId)
    .length;
}
